import { Link } from "react-router-dom";
import medicalFacilities from "../data/medicalFacilities";

function MedicalFacilities() {
    return (
        <div className="py-16 px-4">
            <div className="max-w-7xl mx-auto">
                {/* HEADING */}
                <div className="text-center mb-14">
                    <h1 className="text-3xl md:text-4xl font-bold text-white">
                        Our Medical Facilities
                    </h1>

                    <p className="mt-3 text-white/90">
                        Essential healthcare services with personal care and trust
                    </p>

                </div>

                {/* GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                    {medicalFacilities.map((facility) => (
                        <div
                            key={facility.id}
                            className="bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition"
                        >
                            <img
                                src={facility.image}
                                alt={facility.title}
                                className="h-44 w-full object-cover"
                            />
                            <div className="p-6">
                                <h3 className="text-xl font-bold text-[#0b3c78] mb-1">
                                    {facility.title}
                                </h3>
                                <p className="italic text-sm text-blue-600 mb-3">
                                    “{facility.motto}”
                                </p>
                                <p className="text-sm text-gray-700 mb-4 leading-relaxed">
                                    {facility.overview}
                                </p>
                                <Link
                                    to={`/medical-facilities/${facility.id}`}
                                    className="inline-block text-blue-700 font-semibold hover:underline"
                                >
                                    Know More →
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default MedicalFacilities;
